import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import Loading from "../../../hoc/Loading/Loading";
import axios from "../../../axios";
import {
  groupContentFields,
  groupPrivacyStatusDesc,
  groupERGcategories,
  grpBannerImg,
} from "../../../utils/constants";
import * as actionCreators from "../../../modules/actions/index";
import { connect } from "react-redux";
import Select from "react-select";
import * as url from "../../../utils/url";
import { groupRoles } from "../../../utils/constants";
import GrpBannerImgModal from "../Components/GrpBannerModal.jsx";
import { whiteLabelStyling } from "../../../utils/constants";
import moment from "moment";
import { Modal, ModalBody, Button, Alert } from "reactstrap";
import { createGrpStyle } from "../Components/GrpSelectStyles";
import { isMobile } from "../../../utils/deviceInfo";
import AutocompleteAddress from "../../../components/AddressSearch/AutocompleteAddress";
import EventsMap from "../../../components/AddressSearch/EventsMap";

const text_arr = ["name", "description", "welcomeMessage"];

class GroupSettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      noChange: false,
      isEdited: false,
      name: { value: this.props.group.name, updated: "", isUpdated: false },
      bannerImg: {
        value: this.props.group.bannerImg,
        updated: null,
        isUpdated: false,
      },
      description: {
        value: this.props.group.description,
        updated: "",
        isUpdated: false,
      },
      privacy: {
        value: this.props.group.privacy,
        updated: null,
        isUpdated: false,
      },
      categories: {
        value: this.props.group.categories,
        updated: null,
        isUpdated: false,
      },
      isSuccess: false,
      groupCategories: groupERGcategories,
      group: this.props.group,
      isDescErr: false,
      isBannerOpen: false,
      groupEdits: {},
      searchedUser: "",
      address: {
        value: this.props.group.address || "",
        updated: null,
        isUpdated: false,
      },
      location: {
        value: this.props.group.location || {
          type: "Point",
          coordinates: [0, 0],
        },
        updated: null,
        isUpdated: false,
      },
      welcomeMessage: {
        value: typeof this.props.group.welcomeMessage =="string" ? this.props.group.welcomeMessage : this.props.group.welcomeMessage
          ? this.props.group.welcomeMessage.messageContent ||""
          : "",
        updated: null,
        isUpdated: false,
      },
      isWelcomeMsgErr: false,
    };
  }

  getInitials = (user) => {
    let firstName =
      user.firstName && user.firstName.length > 0 ? user.firstName : "N";
    let lastName =
      user.lastName && user.lastName.length > 0 ? user.lastName : "N";
    return firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
  };

  openBannerModal = () => {
    this.setState((prevState) => ({
      isBannerOpen: !prevState.isBannerOpen,
    }));
  };

  handleKeyPress = (e) => {
    if (e.key === "Enter") {
      // this.handleSubmitTodo();
      // e.preventDefault();
    }
  };

  goBack = () => {
    let { organizationId } = this.props.user.profile;
    let url = `/home/groups/${organizationId._id}/view/${this.props.group._id}`;
    this.props.history.push(url);
  };

  showGrpValue = (key) => {
    // console.log('key -- ', key)
    // console.log('this.state[key] -- ', this.state[key])
    // if(key && key.length)
    let new_val = this.state[key].updated;
    let current = this.state[key].value?this.state[key].value:'';
    let isUpdated = this.state[key].isUpdated;
    if (new_val && isUpdated) {
      return new_val;
    } else {
      return current;
    }
  };

  updateValue = (event, key) => {
    let obj = {
      [key]: { ...this.state[key], updated: event, isUpdated: true },
      isDescErr: false,
      isCatErr: false,
      isEdited: true,
    };

    if (key == "privacy") {
      if (event && event.id) {
        obj = {
          [key]: { ...this.state[key], updated: event.id, isUpdated: true },
          isDescErr: false,
          isCatErr: false,
          isEdited: true,
        };
      }
    }

    if (text_arr.indexOf(key) > -1) {
      const { value } = event.target;
      obj = {
        ...obj,
        [key]: { ...this.state[key], updated: value, isUpdated: true },
      };
      if (key == "description" && value.length > 200) {
        obj = { ...obj, isDescErr: true };
      }
      if (key == "welcomeMessage" && value.length > 200) {
        obj = { ...obj, isWelcomeMsgErr: true };
      }
    }

    if (key == "categories") {
      if (event.length > 3) {
        let { categories } = this.state;
        obj = {
          [key]: {
            ...this.state[key],
            updated: categories.updated,
            isUpdated: true,
          },
          isCatErr: true,
        };
      }
      let res = event.map((e) => e.id);
      groupERGcategories.filter((e) => res.indexOf(e.id) == -1);
      obj = { ...obj, groupCategories: groupERGcategories };
    }

    console.log("obj---", obj);
    this.setState(obj);
  };

  removeBannerImg = () => {
    this.setState({ bannerImg: null });
  };

  setBannerImg = (bannerImg) => {
    this.updateValue(bannerImg, "bannerImg");
  };

  closeSuccess = () => {
    this.setState({ isSuccess: false });
  };

  updateGroup = () => {
    let current = this.state;
    let that = this;

    // let updated_obj = Object.fromEntries(Object.entries(current).filter(([key]) => current[key].isUpdated ));
    // let btest = Object.entries(current).filter(([key]) => current[key].isUpdated )

    // let updated_obj = Object.fromEntries(Object.keys(current).map(e=> [[e], current[e].updated]))

    let updated_obj = Object.fromEntries(
      Object.keys(current)
        .filter((key) => current[key].isUpdated)
        .map((e) => [[e], current[e].updated])
    );

    console.log("updated_obj---", updated_obj);

    if (updated_obj && Object.keys(updated_obj).length > 0) {
      const formData = new FormData();

      updated_obj.welcomeMessage = {
        dateCreated:this.props.group && this.props.group.welcomeMessage && this.props.group.welcomeMessage.dateCreated ? this.props.group.welcomeMessage.dateCreated : new Date(),
        messageContent:updated_obj.welcomeMessage
      }

      formData.append("payload", JSON.stringify(updated_obj));
      formData.append("groupId", JSON.stringify(this.state.group._id));

      if (updated_obj.bannerImg && updated_obj.bannerImg.file) {
        formData.append("uploads", updated_obj.bannerImg.file);
      }

      axios
        .post(url.updateGroup, formData)
        .then(({ data }) => {
          that.setState({ isSuccess: true });

          that.props.updateGroupSettings(updated_obj);
          // let url =`/home/groups/${user.profile.organizationId._id}/view/${groupId}`
          // that.props.history.push({pathname : url });
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      that.setState({
        noChange: true,
      });
    }
  };

  render() {
    let {
      name,
      isSuccess,
      privacy,
      description,
      isBannerOpen,
      members,
      isCatErr,
      isDescErr,
      groupEdits,
      groupCategories,
      categories,
      searchedUser,
      isEdited,
      bannerImg,
      address,
      welcomeMessage,
      isWelcomeMsgErr,
    } = this.state;

    privacy = this.showGrpValue("privacy");

    return (
      <span className="grp_single_page_stories_container_settings">
        <div className="grp_single_page_details_post_container">
          <div
            className={`custom_left_section_menu_fields ${isMobile &&
              "grp-mobile-h"}`}
          >
            {/* <div className="sidebar-menuItem custom_left_menu_section_menuItem">
               <img src={grp_img} className="grp_single_page_cover_img" />
              </div> */}

            <div
              onClick={() => this.openBannerModal()}
              className="grp_settings_image_container"
            >
              <span className="grp_create_page_bannerImg_txt">
                {" "}
                Change image{" "}
              </span>
              <img
                src={
                  this.showGrpValue("bannerImg") &&
                  this.showGrpValue("bannerImg").url
                    ? this.showGrpValue("bannerImg").url
                    : grpBannerImg
                }
                className={`grp_create_page_bannerImg banner banner_filter boxShadow1`}
              />
            </div>

            <div className="floating-label-group">
              <input
                type="text"
                id="name"
                className="form-control"
                // onChange={this.changeGroupName}
                onChange={(value) => this.updateValue(value, "name")}
                value={this.showGrpValue("name")}
                placeholder=" "
                autoComplete="off"
              />
              <label className="floating-label">
                {" "}
                Name{" "}
                {this.showGrpValue("name").length > 0
                  ? ` (${this.showGrpValue("name").length}/75 char)`
                  : "(max 75 char)"}{" "}
              </label>
            </div>

            {/*------ Description for group -----*/}
            <div className="floating-label-group">
              <textarea
                className={"grp_create_description_txt"}
                placeholder=""
                onKeyPress={this.handleKeyPress}
                onChange={(value) => this.updateValue(value, "description")}
                value={this.showGrpValue("description")}
              />
              <label
                className={
                  this.showGrpValue("description") &&
                  this.showGrpValue("description").length > 0
                    ? "floating_label_invite_user"
                    : `floating-label`
                }
              >
                {" "}
                Description{" "}
                {this.showGrpValue("description").length > 0
                  ? ` (${this.showGrpValue("description").length}/200 char)`
                  : "max 200 char"}{" "}
                (optional){" "}
              </label>
              {isDescErr ? (
                <div className="grp_create_description_error">
                  {" "}
                  Group description can not exceed 200 characters.{" "}
                </div>
              ) : null}
            </div>

            {/*------ Welcome message for group -----*/}
            <div className="floating-label-group">
              <textarea
                className={"grp_create_description_txt"}
                placeholder=""
                onKeyPress={this.handleKeyPress}
                onChange={(value) => this.updateValue(value, "welcomeMessage")}
                value={this.showGrpValue("welcomeMessage")}
              />
              <label
                className={
                  this.showGrpValue("welcomeMessage") && this.showGrpValue("welcomeMessage").length > 0
                    ? "floating_label_invite_user"
                    : `floating-label`
                }
              >
                {" "}
                Group welcome message{" "}
                {this.showGrpValue("welcomeMessage").length > 0
                  ? ` (${this.showGrpValue("welcomeMessage").length}/200 char)`
                  : "max 200 char"}{" "}
                (optional)
              </label>
              {isWelcomeMsgErr ? (
                <div className="grp_create_description_error">
                  {" "}
                  Group welcome message can not exceed 200 characters.{" "}
                </div>
              ) : null}
            </div>

            {/* ------ Choose Group Categories ------*/}

            <div className="floating-label-group grp_create_category_container">
              <Select
                name="kpi-select"
                placeholder={""}
                isMulti
                value={
                  this.showGrpValue("categories").length > 0
                    ? this.showGrpValue("categories")
                    : ""
                }
                multi
                isOpen
                // onChange={this.addGroupCategory}
                onChange={(val) => this.updateValue(val, "categories")}
                // onChange={cat => this.addGroupCategory(cat)}
                options={groupCategories}
                valueKey="id"
                labelKey="name"
                getOptionLabel={({ name }) => name}
                getOptionValue={({ id }) => id}
              />
              <label
                className={
                  this.showGrpValue("categories").length > 0
                    ? "floating_label_invite_user"
                    : `floating-label`
                }
              >
                {" "}
                Group types (optional)
              </label>
              {isCatErr ? (
                <div className="grp_create_description_error">
                  {" "}
                  Only choose up to 3 categories.{" "}
                </div>
              ) : null}
              {/* <label className="floating-label">Choose Group categories (optional)</label> */}
            </div>

            <div className="floating-label-group">
              <Select
                name="kpi-select"
                placeholder={""}
                value={
                  groupPrivacyStatusDesc.filter(
                    (e) => e.id == this.showGrpValue("privacy")
                  )[0]
                }
                // optionRenderer={[{}]}
                simpleValue
                onChange={(val) => this.updateValue(val, "privacy")}
                options={groupPrivacyStatusDesc}
                valueKey="id"
                labelKey="name"
                styles={createGrpStyle}
                getOptionLabel={({ name }) => name}
                getOptionValue={({ id }) => id}
              />
              <label
                className={
                  privacy != null
                    ? "floating_label_invite_user"
                    : `floating-label`
                }
              >
                {" "}
                Privacy Status{" "}
              </label>
              {/* <label className="floating-label">Choose Privacy</label> */}
            </div>

            <AutocompleteAddress
              delayClose
              address={this.props.group.address}
              handleSelect={(address, lng, lat) => {
                this.updateValue(address, "address");
                this.updateValue(
                  {
                    type: "Point",
                    coordinates: [lng, lat],
                  },
                  "location"
                );
              }}
              relative
              labelComp={
                <label className="floating-label">Address Location</label>
              }
              floatingLabel={true}
            />

            <div className="mt-5">
              <EventsMap
                item={{
                  location: this.state.location.updated
                    ? this.state.location.updated
                    : this.state.location,
                }}
                lefletHeightClass={"lh-200"}
              />
            </div>

            <div className="single_grp_settings_btn_container">
              <div
                className={
                  isEdited
                    ? `custom_left_menu_create_button active`
                    : `custom_left_menu_create_button`
                }
                onClick={isEdited ? () => this.updateGroup() : null}
              >
                Update
              </div>

              <div
                className="single_grp_settings_btn_back"
                onClick={() => this.goBack()}
              >
                Back
              </div>
            </div>
          </div>
        </div>

        <div className="grp_single_page_privacy_status_info">
          <span className="grp_create_page_privacy_status_details title">
            About
          </span>
          <span className="grp_create_page_privacy_status_details description">
            {/* {this.showGrpValue("description")} */}
            {this.state.description.value}
          </span>
          {privacy ? (
            <span className="grp_create_page_privacy_status_details option">
              {groupContentFields(privacy).name}
              <span> {groupContentFields(privacy).description} </span>
              <span> {groupContentFields(privacy).permission} </span>
            </span>
          ) : (
            <span>
              {groupPrivacyStatusDesc.map((e, idx) => {
                return (
                  <span
                    className="grp_create_page_privacy_status_details option"
                    key={idx + e.id}
                  >
                    {e.name}
                    <span> {e.description} </span>
                  </span>
                );
              })}
            </span>
          )}

          {isSuccess ? (
            <Alert
              color="success"
              isOpen={isSuccess}
              onClose={() => this.closeSuccess()}
              dismissible
            >
              {this.showGrpValue("name")} was successfully updated.
            </Alert>
          ) : null}
        </div>

        <GrpBannerImgModal
          removeBannerImg={this.removeBannerImg}
          setBannerImg={this.setBannerImg}
          image={bannerImg}
          openBannerModal={this.openBannerModal}
          isBannerOpen={isBannerOpen}
        />
      </span>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user,
    kpiMaster: state.kpiMaster,
    mappingMaster: state.mappingMaster,
    reports: state.reports,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onKpiMasterListFetched: (data) =>
      dispatch(actionCreators.storeKpiMaster(data)),
    onMappingMasterListFetched: (data) =>
      dispatch(actionCreators.storeMappingMaster(data)),
    onProfileUpdate: (data) =>
      dispatch(actionCreators.updateProfileInfoSuccess(data)),
    updateNavBar: (header) => dispatch(actionCreators.navBarUpdate(header)),
    updateReport: (dashboard) =>
      dispatch(actionCreators.updateReport(dashboard)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Loading(GroupSettings, axios)));
